import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeroBanner from '../Component/Home/HeroBanner';
import HomeCategory from '../Component/Home/HomeCategory';
import FreshArrivals from '../Component/Home/FreshArrivals';
import Bestsellar from '../Component/Home/Bestsellar';
import ModerCarpet from '../Component/Home/ModerCarpet';
import Offer from '../Component/Home/Offer';
import NewCollection from '../Component/Home/NewCollection';

const HomeIndex = () => {
 const location = useLocation();
 const navigate = useNavigate();

 useEffect(() => {
    if (location.state?.scrollTarget === 'homeCategory') {
      const section = document.getElementById('home-category-section');
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
      navigate(location.pathname, { replace: true, state: {} });
    }
 }, [location, navigate]);

 return(
    <> 
      <HeroBanner/>
      <HomeCategory/>
      <ModerCarpet/>
      <FreshArrivals/>
      <Bestsellar/>
      <Offer/>
      <NewCollection/>
   </>
 )
}
export default HomeIndex;